<template>
  <legend class="mb-4">{{title}}
    <div class="loading-indicator" :class="{spin: isSpinning}">
      <img class="img-fluid" src="@/assets/aio-marque.png" alt="aio* marque">
    </div>
  </legend>
</template>

<script>
  import EventBus from '@/utils/EventBus'

  export default {
    data () {
      return {
        isSpinning: false
      }
    },
    mounted () {
      EventBus.$on('ajax-start', () => { this.isSpinning = true })
      EventBus.$on('ajax-stop', () => { this.isSpinning = false })
    },
    props: {
      title: String
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .loading-indicator {
    color: $el-salmon;
    float: right;
    position: relative;
    bottom: 18px;
    width: 32px;
  }

  .spin {
    animation: spin 2s infinite linear;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
</style>
